import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaCalendarPlus,
  FaTicketAlt,
  FaUserCheck,
  FaListAlt,
} from 'react-icons/fa';

import GlobalHeader from '../../../../components/GlobalHeader.jsx';
import '../css/EventManagement.css';

const RequestCard = () => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  useEffect(() => {
    console.log('[RequestCard] 📁 Event Management hub mounted — no API call, static navigation only. Routes: /event-request (pending events), /tickets-event-list (tickets per event), /attendance (scan & check-in)');
  }, []);

  return (
    <div className="event-management-container">
      <GlobalHeader
        title="Request Management"
        subtitle="Manage your event requests and ticket information"
        backTo="/organiser-dash"
        logoutTo="/"
        onLogout={() => {
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          localStorage.removeItem('user');
          navigate('/');
        }}
      />

      <main className="event-management-main">
        <section className="cards-section">
          <div className="cards-grid">
            <div 
              className="management-card"
              onClick={() => handleCardClick('/event-request')}
            >
              <div className="card-icon">
                <FaCalendarPlus />
              </div>
              <div className="card-content">
                <h3>Events Pending Approval</h3>
                <p>View and manage events awaiting approval</p>
              </div>
            </div>
            <div 
              className="management-card"
              onClick={() => handleCardClick('/tickets-event-list')}
            >
              <div className="card-icon">
                <FaTicketAlt />
              </div>
              <div className="card-content">
                <h3>Tickets Per Event</h3>
                <p>View ticket sales by event</p>
              </div>
            </div>
            <div
              className="management-card"
              onClick={() => handleCardClick('/attendance')}
            >
              <div className="card-icon">
                <FaUserCheck />
              </div>
              <div className="card-content">
                <h3>Capture Attendance</h3>
                <p>Track event attendance</p>
              </div>
            </div>
            <div
              className="management-card"
              onClick={() => handleCardClick('/my-events')}
            >
              <div className="card-icon">
                <FaListAlt />
              </div>
              <div className="card-content">
                <h3>View My Events</h3>
                <p>See all your events and their statuses</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default RequestCard;

